
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/products",
      function () {
        return require("private-next-pages/admin/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/products"])
      });
    }
  